import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { RemoveAccessActionDefinitionModel } from "src/app/models/api/playbooks/actions/removeAccessProperties";
import { TriggerTypes } from "src/app/models/api/playbooks/triggers/triggerTypes.enum";
import { PlaybooksActionDefinitionInput } from "src/app/models/componentInputs/playbookActionInput.interface";
import { PlaybooksTriggerActionsService } from "src/app/services/actions/playbooks/playbooks-trigger-actions/playbooks-trigger-actions.service";

@Component({
    selector: "app-remove-access-action",
    templateUrl: "./remove-access-action.component.html",
    styleUrls: ["./remove-access-action.component.scss"],
})
export class RemoveAccessActionComponent implements OnInit {
    @Input() public fg: UntypedFormGroup;
    @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
    @Input() public triggerType: TriggerTypes;
    public supportedRulesIdAndDescription: string[] = [];

    private _supportedRules = new Set<string>([
        "ZN_P00200",
        "ZN_P00201",
        "ZN_P00202",
        "ZN_P00203",
        "ZN_P00204",
        "ZN_P00205",
        "ZN_P00206",
        "ZN_P00207",
        "ZN_P00208",
        "ZN_P00209",
        "ZN_P00210",
        "ZN_P00211",
        "ZN_P00212",
        "ZN_P00214",
        "ZN_P00046",
        "ZN_P00048",
        "ZN_P00143",
        "ZN_P00146",
    ]);

    private _removeAccessActionDefinitionModel?: RemoveAccessActionDefinitionModel;

    constructor(private _playbooksTriggerActionsService: PlaybooksTriggerActionsService) {
        this.supportedRulesIdAndDescription = _playbooksTriggerActionsService
            .getRulesByIds(this._supportedRules)
            .map((rule) => `${rule.id} - ${rule.displayName}`);
    }

    ngOnInit(): void {
        if (this.playbooksActionInput.actionDefinitionProperties) {
            this._removeAccessActionDefinitionModel = this.playbooksActionInput.actionDefinitionProperties as RemoveAccessActionDefinitionModel;
            this._removeAccessActionDefinitionModel.replaceOwnerEmail = ""; // for future support
        }
    }
}
